var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "div",
            [
              _vm.activeTabName === "deviceManagerTab"
                ? _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        placeholder: "Chọn thiết bị",
                        "value-key": "id",
                      },
                      on: { change: _vm.getChangeDeviceRecognition },
                      model: {
                        value: _vm.idDevice,
                        callback: function ($$v) {
                          _vm.idDevice = $$v
                        },
                        expression: "idDevice",
                      },
                    },
                    _vm._l(_vm.listIdDevice, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.id,
                          attrs: { value: item.id, label: item.nameDevice },
                        },
                        [_c("span", [_vm._v(_vm._s(item.nameDevice))])]
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleClickTab },
              model: {
                value: _vm.activeTabName,
                callback: function ($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "Quản lý thiết bị",
                    name: "deviceManagerTab",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      ref: "multipleTable",
                      attrs: {
                        "empty-text": _vm.textUserDevice,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        "highlight-current-row": "",
                        data: _vm.listDataUserDevice,
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "STT",
                          width: "50",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "Họ và tên" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ảnh",
                          width: "200px",
                          align: "center",
                          prop: "urlWebFace",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("el-image", {
                                      staticClass: "el-image-opacity",
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        "object-fit": "cover",
                                      },
                                      attrs: { src: scope.row.urlWebFace },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showPictureOnDevice(
                                            scope.row.urlWebFace
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "startTime",
                          label: "Thời gian bắt đầu",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "endTime", label: "Thời gian kết thúc" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Tác vụ",
                          width: "200",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleApply(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("Áp dụng\n              ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("Xóa\n              ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "20px",
                        display: "flex",
                        "justify-content": "flex-end",
                      },
                    },
                    [
                      _c(
                        "el-menu",
                        {
                          attrs: {
                            "background-color": "#67C23A",
                            "text-color": "#FFFFFF",
                            "active-text-color": "#FFFFFF",
                            mode: "horizontal",
                            "unique-opened": true,
                            "menu-trigger": "hover",
                          },
                        },
                        [
                          _c(
                            "el-submenu",
                            {
                              staticClass: "sub_menu",
                              attrs: { index: "1", "popper-class": "sub_menu" },
                              scopedSlots: _vm._u([
                                {
                                  key: "title",
                                  fn: function () {
                                    return [_c("span", [_vm._v("Tác vụ")])]
                                  },
                                  proxy: true,
                                },
                              ]),
                            },
                            [
                              _c("el-menu-item", {
                                attrs: { index: "2" },
                                on: { click: _vm.getChangeDeviceRecognition },
                                scopedSlots: _vm._u([
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c("span", [_vm._v("Lấy dữ liệu")]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _c("el-menu-item", {
                                attrs: { index: "3" },
                                on: {
                                  click: _vm.handleOpenSynchronizeDeviceDialog,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c("span", [
                                          _vm._v("Đồng bộ thiết bị"),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "Cấu hình điểm danh",
                    name: "AttendanceConfigTab",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      staticClass: "attendance-config-container",
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "ruleForm",
                          attrs: {
                            model: _vm.configRecognitionResponse,
                            rules: _vm.rules,
                            "label-position": "top",
                          },
                        },
                        [
                          _c("div", { staticClass: "setting-card" }, [
                            _c("div", { staticClass: "setting-card-header" }, [
                              _c("i", {
                                staticClass: "el-icon-circle-check header-icon",
                              }),
                              _c("span", [
                                _vm._v("Chế độ & Xác thực điểm danh"),
                              ]),
                            ]),
                            _c("div", { staticClass: "setting-card-body" }, [
                              _c("div", { staticClass: "setting-row" }, [
                                _c("div", { staticClass: "setting-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "setting-title" },
                                    [
                                      _vm._v(
                                        "\n                      Chế độ điểm danh, chấm công AI\n                      "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("div", {
                                            attrs: { slot: "content" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.tooltips.attendanceMode
                                              ),
                                            },
                                            slot: "content",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question help-icon",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "setting-desc" }, [
                                    _vm._v(
                                      "Cấu hình điểm danh bằng AI tự động hoặc xác thực thủ công."
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "setting-control" },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: { size: "medium" },
                                        model: {
                                          value:
                                            _vm.configRecognitionResponse
                                              .attendanceMode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.configRecognitionResponse,
                                              "attendanceMode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "configRecognitionResponse.attendanceMode",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio-button",
                                          { attrs: { label: "manualAndAuto" } },
                                          [_vm._v("Tự động")]
                                        ),
                                        _c(
                                          "el-radio-button",
                                          { attrs: { label: "manual" } },
                                          [_vm._v("Thủ công")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "setting-row" }, [
                                _c("div", { staticClass: "setting-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "setting-title" },
                                    [
                                      _vm._v(
                                        "\n                      Xác nhận điểm danh, chấm công\n                      "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("div", {
                                            attrs: { slot: "content" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.tooltips.confirm
                                              ),
                                            },
                                            slot: "content",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question help-icon",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "setting-desc" }, [
                                    _vm._v(
                                      "Yêu cầu người quản lý xác nhận lại kết quả quét được."
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "setting-control" },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.configRecognitionResponse.confirm,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.configRecognitionResponse,
                                            "confirm",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "configRecognitionResponse.confirm",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "setting-row" }, [
                                _c("div", { staticClass: "setting-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "setting-title" },
                                    [
                                      _vm._v(
                                        "\n                      Gửi ảnh đã xác thực khi điểm danh\n                      "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("div", {
                                            attrs: { slot: "content" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.tooltips.applyPicture
                                              ),
                                            },
                                            slot: "content",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question help-icon",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "setting-desc" }, [
                                    _vm._v(
                                      "Đính kèm hình ảnh khuôn mặt thực tế khi điểm danh AI."
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "setting-control" },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.configRecognitionResponse
                                            .applyPicture,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.configRecognitionResponse,
                                            "applyPicture",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "configRecognitionResponse.applyPicture",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm.checkPermission([
                                "studentQuality_attendance",
                              ]) ||
                              _vm.checkPermission([
                                "studentQuality_attendance_v2",
                              ])
                                ? _c("div", { staticClass: "setting-row" }, [
                                    _c("div", { staticClass: "setting-info" }, [
                                      _c(
                                        "div",
                                        { staticClass: "setting-title" },
                                        [
                                          _vm._v(
                                            "\n                      Học sinh nghỉ mà đã được xác nhận thì có điểm danh lại không?\n                      "
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("div", {
                                                attrs: { slot: "content" },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.tooltips
                                                      .authenticationWhenAbsent
                                                  ),
                                                },
                                                slot: "content",
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-question help-icon",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "setting-desc" },
                                        [
                                          _vm._v(
                                            "Cho phép thiết bị quét điểm danh lại khi học sinh nghỉ có phép/không phép đã được duyệt trước đó."
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "setting-control" },
                                      [
                                        _c("el-switch", {
                                          model: {
                                            value:
                                              _vm.configRecognitionResponse
                                                .authenticationWhenAbsent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.configRecognitionResponse,
                                                "authenticationWhenAbsent",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "configRecognitionResponse.authenticationWhenAbsent",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "setting-row" }, [
                                _c("div", { staticClass: "setting-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "setting-title" },
                                    [
                                      _vm._v(
                                        "\n                      Nhân viên có chấm công bằng khuôn mặt hay không?\n                      "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("div", {
                                            attrs: { slot: "content" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.tooltips
                                                  .teachersAttendanceWithFaces
                                              ),
                                            },
                                            slot: "content",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question help-icon",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "setting-desc" }, [
                                    _vm._v(
                                      "Bật/Tắt tính năng chấm công nhận diện khuôn mặt cho giáo viên và nhân viên."
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "setting-control" },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.configRecognitionResponse
                                            .teachersAttendanceWithFaces,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.configRecognitionResponse,
                                            "teachersAttendanceWithFaces",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "configRecognitionResponse.teachersAttendanceWithFaces",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("div", { staticClass: "setting-row" }, [
                                _c("div", { staticClass: "setting-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "setting-title" },
                                    [
                                      _vm._v(
                                        "\n                      Tự động xác nhận điểm danh, chẩm công trong thời gian thủ công?\n                      "
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("div", {
                                            attrs: { slot: "content" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.tooltips.manualStillConfirm
                                              ),
                                            },
                                            slot: "content",
                                          }),
                                          _c("i", {
                                            staticClass:
                                              "el-icon-question help-icon",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "setting-desc" }, [
                                    _vm._v(
                                      "Bật tự động duyệt chấm công ngay cả ngoài khung giờ tự động cấu hình."
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "setting-control" },
                                  [
                                    _c("el-switch", {
                                      model: {
                                        value:
                                          _vm.configRecognitionResponse
                                            .manualStillConfirm,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.configRecognitionResponse,
                                            "manualStillConfirm",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "configRecognitionResponse.manualStillConfirm",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "setting-card" }, [
                            _c("div", { staticClass: "setting-card-header" }, [
                              _c("i", {
                                staticClass: "el-icon-edit-outline header-icon",
                              }),
                              _c("span", [
                                _vm._v("Thông số tùy chỉnh & Tên hiển thị"),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "setting-card-body" },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label:
                                                "Thời gian tồn tại yêu cầu xác nhận",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-unit-wrapper",
                                              },
                                              [
                                                _c("el-input-number", {
                                                  staticClass:
                                                    "compact-input-number",
                                                  attrs: {
                                                    min: 5,
                                                    max: 20,
                                                    size: "mini",
                                                    placeholder: "Số giây",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm
                                                        .configRecognitionResponse
                                                        .attendanceStatusTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.configRecognitionResponse,
                                                        "attendanceStatusTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configRecognitionResponse.attendanceStatusTime",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "unit-label" },
                                                  [_vm._v("giây")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label:
                                                "Tên tùy chỉnh xác nhận đến",
                                              prop: "labelCheckIn",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "modern-input",
                                              attrs: {
                                                size: "mini",
                                                placeholder:
                                                  "Nhập tên nhãn xác nhận đến",
                                              },
                                              model: {
                                                value:
                                                  _vm.configRecognitionResponse
                                                    .labelCheckIn,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.configRecognitionResponse,
                                                    "labelCheckIn",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "configRecognitionResponse.labelCheckIn",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 8 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label:
                                                "Tên tùy chỉnh xác nhận về",
                                              prop: "labelCheckOut",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "modern-input",
                                              attrs: {
                                                size: "mini",
                                                placeholder:
                                                  "Nhập tên nhãn xác nhận về",
                                              },
                                              model: {
                                                value:
                                                  _vm.configRecognitionResponse
                                                    .labelCheckOut,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.configRecognitionResponse,
                                                    "labelCheckOut",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "configRecognitionResponse.labelCheckOut",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "setting-card" }, [
                            _c("div", { staticClass: "setting-card-header" }, [
                              _c("i", {
                                staticClass: "el-icon-time header-icon",
                              }),
                              _c("span", [
                                _vm._v("Khung giờ tự động xác nhận đến / về"),
                              ]),
                            ]),
                            _c("div", { staticClass: "setting-card-body" }, [
                              _c("div", { staticClass: "time-config-grid" }, [
                                _vm.checkPermission([
                                  "studentQuality_attendance",
                                ]) ||
                                _vm.checkPermission([
                                  "studentQuality_attendance_v2",
                                ]) ||
                                _vm.checkPermission(["attendance_v4"])
                                  ? _c("div", { staticClass: "time-block" }, [
                                      _c(
                                        "div",
                                        { staticClass: "time-block-title" },
                                        [
                                          _vm._v(
                                            "\n                      Thời gian tự động xác nhận đến\n                      "
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("div", {
                                                attrs: { slot: "content" },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.tooltips
                                                      .timeAutoArriveHour
                                                  ),
                                                },
                                                slot: "content",
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-question help-icon",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "time-range-picker-row",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "time-input-group" },
                                            [
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 24,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoArriveHour1,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoArriveHour1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoArriveHour1",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "sep" },
                                                [_vm._v(":")]
                                              ),
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 59,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoArriveMinute1,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoArriveMinute1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoArriveMinute1",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "range-arrow" },
                                            [_vm._v("đến")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "time-input-group" },
                                            [
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 24,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoArriveHour2,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoArriveHour2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoArriveHour2",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "sep" },
                                                [_vm._v(":")]
                                              ),
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 59,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoArriveMinute2,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoArriveMinute2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoArriveMinute2",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.checkPermission([
                                  "studentQuality_attendance",
                                ]) || _vm.checkPermission(["attendance_v4"])
                                  ? _c("div", { staticClass: "time-block" }, [
                                      _c(
                                        "div",
                                        { staticClass: "time-block-title" },
                                        [
                                          _vm._v(
                                            "Thời gian tự động xác nhận về cho học sinh"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "time-range-picker-row",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "time-input-group" },
                                            [
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 24,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoLeaveHour1,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoLeaveHour1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoLeaveHour1",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "sep" },
                                                [_vm._v(":")]
                                              ),
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 59,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoLeaveMinute1,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoLeaveMinute1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoLeaveMinute1",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "range-arrow" },
                                            [_vm._v("đến")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "time-input-group" },
                                            [
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 24,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoLeaveHour2,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoLeaveHour2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoLeaveHour2",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "sep" },
                                                [_vm._v(":")]
                                              ),
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 59,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoLeaveMinute2,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoLeaveMinute2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoLeaveMinute2",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.checkPermission([
                                  "studentQuality_attendance",
                                ]) ||
                                _vm.checkPermission([
                                  "studentQuality_attendance_v2",
                                ]) ||
                                _vm.checkPermission(["attendance_v4"])
                                  ? _c("div", { staticClass: "time-block" }, [
                                      _c(
                                        "div",
                                        { staticClass: "time-block-title" },
                                        [
                                          _vm._v(
                                            "Thời gian tự động xác nhận về cho giáo viên"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "time-range-picker-row",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "time-input-group" },
                                            [
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 24,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoLeaveHourTeacher1,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoLeaveHourTeacher1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoLeaveHourTeacher1",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "sep" },
                                                [_vm._v(":")]
                                              ),
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 59,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoLeaveMinuteTeacher1,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoLeaveMinuteTeacher1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoLeaveMinuteTeacher1",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "range-arrow" },
                                            [_vm._v("đến")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "time-input-group" },
                                            [
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 24,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoLeaveHourTeacher2,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoLeaveHourTeacher2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoLeaveHourTeacher2",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "sep" },
                                                [_vm._v(":")]
                                              ),
                                              _c("el-input-number", {
                                                attrs: {
                                                  min: 0,
                                                  max: 59,
                                                  size: "mini",
                                                },
                                                model: {
                                                  value:
                                                    _vm
                                                      .configRecognitionResponse
                                                      .timeAutoLeaveMinuteTeacher2,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.configRecognitionResponse,
                                                      "timeAutoLeaveMinuteTeacher2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "configRecognitionResponse.timeAutoLeaveMinuteTeacher2",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                          ]),
                          _vm.checkPermission(["studentQuality_attendance"]) ||
                          _vm.checkPermission([
                            "studentQuality_attendance_v2",
                          ]) ||
                          _vm.checkPermission(["attendance_v4"])
                            ? _c("div", { staticClass: "setting-card" }, [
                                _c(
                                  "div",
                                  { staticClass: "setting-card-header" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-date header-icon",
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        "Khung giờ học các buổi trong ngày"
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "setting-card-body" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "time-config-grid three-cols",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "time-block" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "time-block-title blue-badge",
                                              },
                                              [
                                                _vm._v(
                                                  "Thời gian học buổi sáng"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "time-range-picker-row",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "time-input-group",
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 24,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .morningSchoolTimeHour1,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "morningSchoolTimeHour1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.morningSchoolTimeHour1",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sep" },
                                                      [_vm._v(":")]
                                                    ),
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 59,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .morningSchoolTimeMinute1,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "morningSchoolTimeMinute1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.morningSchoolTimeMinute1",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "range-arrow",
                                                  },
                                                  [_vm._v("đến")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "time-input-group",
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 24,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .morningSchoolTimeHour2,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "morningSchoolTimeHour2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.morningSchoolTimeHour2",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sep" },
                                                      [_vm._v(":")]
                                                    ),
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 59,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .morningSchoolTimeMinute2,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "morningSchoolTimeMinute2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.morningSchoolTimeMinute2",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "time-block" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "time-block-title orange-badge",
                                              },
                                              [
                                                _vm._v(
                                                  "Thời gian học buổi chiều"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "time-range-picker-row",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "time-input-group",
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 24,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .afternoonSchoolTimeHour1,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "afternoonSchoolTimeHour1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.afternoonSchoolTimeHour1",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sep" },
                                                      [_vm._v(":")]
                                                    ),
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 59,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .afternoonSchoolTimeMinute1,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "afternoonSchoolTimeMinute1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.afternoonSchoolTimeMinute1",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "range-arrow",
                                                  },
                                                  [_vm._v("đến")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "time-input-group",
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 24,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .afternoonSchoolTimeHour2,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "afternoonSchoolTimeHour2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.afternoonSchoolTimeHour2",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sep" },
                                                      [_vm._v(":")]
                                                    ),
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 59,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .afternoonSchoolTimeMinute2,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "afternoonSchoolTimeMinute2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.afternoonSchoolTimeMinute2",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "time-block" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "time-block-title purple-badge",
                                              },
                                              [_vm._v("Thời gian học buổi tối")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "time-range-picker-row",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "time-input-group",
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 24,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .eveningSchoolHour1,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "eveningSchoolHour1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.eveningSchoolHour1",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sep" },
                                                      [_vm._v(":")]
                                                    ),
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 59,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .eveningSchoolMinute1,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "eveningSchoolMinute1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.eveningSchoolMinute1",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "range-arrow",
                                                  },
                                                  [_vm._v("đến")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "time-input-group",
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 24,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .eveningSchoolHour2,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "eveningSchoolHour2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.eveningSchoolHour2",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      { staticClass: "sep" },
                                                      [_vm._v(":")]
                                                    ),
                                                    _c("el-input-number", {
                                                      attrs: {
                                                        min: 0,
                                                        max: 59,
                                                        size: "mini",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .configRecognitionResponse
                                                            .eveningSchoolMinute2,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.configRecognitionResponse,
                                                            "eveningSchoolMinute2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "configRecognitionResponse.eveningSchoolMinute2",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.checkPermission(["studentQuality_attendance_v2"])
                            ? _c(
                                "div",
                                {
                                  staticClass: "setting-card shift-config-card",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "setting-card-header" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-document-copy header-icon",
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          "Khung giờ tự động xác nhận theo ca học (V2)"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "setting-card-body" },
                                    [
                                      _c("div", { staticClass: "shift-grid" }, [
                                        _c(
                                          "div",
                                          { staticClass: "shift-card-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "shift-card-header morning",
                                              },
                                              [_vm._v("Ca Sáng")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "shift-card-body",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "time-block" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-block-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tự động xác nhận đến"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-range-picker-row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoStartShiftMorningHour1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoStartShiftMorningHour1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoStartShiftMorningHour1",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoStartShiftMorningMinute1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoStartShiftMorningMinute1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoStartShiftMorningMinute1",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "range-arrow",
                                                          },
                                                          [_vm._v("đến")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoEndShiftMorningHour2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoEndShiftMorningHour2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoEndShiftMorningHour2",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoEndShiftMorningMinute2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoEndShiftMorningMinute2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoEndShiftMorningMinute2",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "time-block" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-block-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tự động xác nhận về"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-range-picker-row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoStartShiftMorningHour1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoStartShiftMorningHour1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoStartShiftMorningHour1",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoStartShiftMorningMinute1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoStartShiftMorningMinute1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoStartShiftMorningMinute1",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "range-arrow",
                                                          },
                                                          [_vm._v("đến")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoEndShiftMorningHour2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoEndShiftMorningHour2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoEndShiftMorningHour2",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoEndShiftMorningMinute2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoEndShiftMorningMinute2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoEndShiftMorningMinute2",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "shift-card-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "shift-card-header afternoon",
                                              },
                                              [_vm._v("Ca Chiều")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "shift-card-body",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "time-block" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-block-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tự động xác nhận đến"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-range-picker-row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoStarShiftAfternoonHour1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoStarShiftAfternoonHour1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoStarShiftAfternoonHour1",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoStarShiftAfternoonMinute1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoStarShiftAfternoonMinute1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoStarShiftAfternoonMinute1",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "range-arrow",
                                                          },
                                                          [_vm._v("đến")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoEndShiftAfternoonHour2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoEndShiftAfternoonHour2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoEndShiftAfternoonHour2",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoEndShiftAfternoonMinute2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoEndShiftAfternoonMinute2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoEndShiftAfternoonMinute2",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "time-block" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-block-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tự động xác nhận về"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-range-picker-row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoStartShiftAfternoonHour1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoStartShiftAfternoonHour1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoStartShiftAfternoonHour1",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoStartShiftAfternoonMinute1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoStartShiftAfternoonMinute1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoStartShiftAfternoonMinute1",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "range-arrow",
                                                          },
                                                          [_vm._v("đến")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoEndShiftAfternoonHour2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoEndShiftAfternoonHour2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoEndShiftAfternoonHour2",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoEndShiftAfternoonMinute2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoEndShiftAfternoonMinute2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoEndShiftAfternoonMinute2",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "shift-card-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "shift-card-header evening",
                                              },
                                              [_vm._v("Ca Tối")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "shift-card-body",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "time-block" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-block-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tự động xác nhận đến"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-range-picker-row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoStartShiftEveningHour1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoStartShiftEveningHour1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoStartShiftEveningHour1",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoStartShiftEveningMinute1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoStartShiftEveningMinute1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoStartShiftEveningMinute1",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "range-arrow",
                                                          },
                                                          [_vm._v("đến")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoEndShiftEveningHour2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoEndShiftEveningHour2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoEndShiftEveningHour2",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeArriveAutoEndShiftEveningMinute2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeArriveAutoEndShiftEveningMinute2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeArriveAutoEndShiftEveningMinute2",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "time-block" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-block-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tự động xác nhận về"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "time-range-picker-row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoStartShiftEveningHour1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoStartShiftEveningHour1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoStartShiftEveningHour1",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoStartShiftEveningMinute1,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoStartShiftEveningMinute1",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoStartShiftEveningMinute1",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "range-arrow",
                                                          },
                                                          [_vm._v("đến")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "time-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 24,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoEndShiftEveningHour2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoEndShiftEveningHour2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoEndShiftEveningHour2",
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sep",
                                                              },
                                                              [_vm._v(":")]
                                                            ),
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0,
                                                                  max: 59,
                                                                  size: "mini",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .configRecognitionResponse
                                                                      .timeLeaveAutoEndShiftEveningMinute2,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.configRecognitionResponse,
                                                                        "timeLeaveAutoEndShiftEveningMinute2",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "configRecognitionResponse.timeLeaveAutoEndShiftEveningMinute2",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "action-footer" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "save-btn",
                                  attrs: {
                                    type: "success",
                                    size: "medium",
                                    loading: _vm.loadingSubmit,
                                  },
                                  on: { click: _vm.onSubmit },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-circle-check",
                                  }),
                                  _vm._v(
                                    "\n                Lưu cấu hình\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { width: "30%", visible: _vm.dialogVisibleImg },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleImg = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.urlPictureUser, alt: "" },
          }),
        ]
      ),
      _c("ApplicableToUsersDialog", {
        attrs: {
          idUserDeviceRecognition: _vm.idUserDeviceRecognition,
          idDevice: _vm.idDevice,
          showApplicableToUsersDialog: _vm.showApplicableToUsersDialog,
        },
        on: { close: _vm.handleCloseApplicableToUsersDialog },
      }),
      _c("SynchronizeDeviceDialog", {
        attrs: {
          idDeviceOld: _vm.idDevice,
          showSynchronizeDeviceDialog: _vm.showSynchronizeDeviceDialog,
        },
        on: {
          close: _vm.handleSynchronizeDeviceDialog,
          resume: _vm.handleOpenSynchronizeDeviceDialog,
          synchronized: _vm.getDataInit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }